export default __webpack_public_path__ + "static/media/mdrrmo_logo.f9fea064.png";